import React from "react";
import { formatMoney } from "../../utils/eventDetailHelpers";
import "./DayWisePriceTable.css";

export default function DayWisePriceTable({
  priceRows,
  showMaleFemaleColumns = false,
  selectedDayLabel = "",
  title = "Price (Day-wise)",
}) {
  if (!Array.isArray(priceRows) || !priceRows.length) return null;

  return (
    <section className="day-wise-price-section">
      <h2 className="day-wise-price-title">{title}</h2>
      <div className="day-wise-price-table-wrap rounded-3">
        <table className="day-wise-price-table w-100 mb-0">
          <thead>
            <tr>
              <th scope="col">Day</th>
              {showMaleFemaleColumns ? (
                <>
                  <th scope="col">Male</th>
                  <th scope="col">Female</th>
                </>
              ) : (
                <th scope="col">Price</th>
              )}
            </tr>
          </thead>
          <tbody>
            {priceRows.map((row, idx) => {
              const isSelected =
                selectedDayLabel && row.dayLabel === selectedDayLabel;
              return (
                <tr
                  key={`${row.dayLabel}-${idx}`}
                  className={isSelected ? "day-wise-price-row-selected" : ""}
                >
                  <td>{row.dayLabel}</td>
                  {showMaleFemaleColumns ? (
                    <>
                      <td>{row.male != null ? formatMoney(row.male) : "—"}</td>
                      <td>{row.female != null ? formatMoney(row.female) : "—"}</td>
                    </>
                  ) : (
                    <td>
                      {row.male != null
                        ? formatMoney(row.male)
                        : row.female != null
                          ? formatMoney(row.female)
                          : "—"}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
